import { useAppReduxSelector } from "hooks/reduxHooks";
import { TextEditor } from "react-data-grid";
import { getIntTotalVol } from "../../NucleofectionToolHelpers";
import { WellMapping } from "../WellMapping";

export const NucToIntMapping = () => {
  const nucPlateInfo = useAppReduxSelector(
    (state) => state.WorklistTools.NucleofectionTool.present.nucPlateInfo
  );

  const intTotalVol = getIntTotalVol(
    nucPlateInfo[0].topUpVol,
    nucPlateInfo[0].washVol,
    nucPlateInfo[0].numberOfWashes
  );

  const worklistValues = useAppReduxSelector(
    (state) => state.WorklistTools.NucleofectionTool.present.worklistValues
  );

  const columns = [
    { key: "sourceWellId", name: "Nuc Pos", resizable: true },
    { key: "destWellId", name: "Int Pos", resizable: true },
    {
      key: "transferVol",
      name: "Transfer Vol",
      resizable: true,
      editor: TextEditor,
      editable: false,
      formatter() {
        return <>{intTotalVol}</>;
      },
    },
  ];

  return (
    <WellMapping columns={columns} worklistValues={worklistValues.nucToInt} />
  );
};
